/**
 * 判断是否是数字
 */

export const isNumber = (value: any): boolean => {
  return typeof value === "number";
};
